import { get, post } from './utils';

export async function fetchAccessApi(data) {
  return post('/api/access', data);
}